import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";
import { SubscriptionPlanSelector } from "./SubscriptionPlanSelector";

const ChooseSubscription = Loadable(
  lazy(() =>
    import("./chooseSubscription").then(({ ChooseSubscription }) => ({
      default: ChooseSubscription,
    })),
  ),
);

export const ChooseSubscriptionRoutes = [
  {
    path: "/choose-subscription",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SUBSCRIPTION]}>
        <ChooseSubscription />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.subscription.choose,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <SubscriptionPlanSelector />
      </AuthorizedRoute>
    ),
  },
];
